/**
 * @generated SignedSource<<49e0ab2db2f59828a2101b91626d3d2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveCustomer_charge$data = {
  readonly customer: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly type: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveCustomerPixCreditCard_charge">;
  readonly " $fragmentType": "PaymentActiveCustomer_charge";
};
export type PaymentActiveCustomer_charge$key = {
  readonly " $data"?: PaymentActiveCustomer_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveCustomer_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveCustomer_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveCustomerPixCreditCard_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "f7978d04834252023ed1333c6d00fb00";

export default node;
